import { render, staticRenderFns } from "./listaCodigos.vue?vue&type=template&id=74ea6554"
import script from "./listaCodigos.vue?vue&type=script&lang=js"
export * from "./listaCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports